<div class="plan-selection">
    <div fxLayout="row wrap" fxLayoutGap="16px grid">
        <div *ngFor="let plan of customerPlans"
            fxFlex="calc(33.33% - 16px)"
            fxFlex.lt-lg="calc(50% - 16px)"
            fxFlex.lt-md="100"
            class="plan-card"
            [class.selected]="selectedPlan?.id === plan.id"
            [class.disabled]="isContractSigned(plan)"
            [matTooltip]="isContractSigned(plan) ? 'Este plano já possui um contrato assinado' : ''"
            (click)="onPlanSelect(plan)">

            <div class="plan-card-content">
                <div class="plan-header">
                    <h4>{{ plan.system.name }}</h4>
                    <span class="plan-type">{{ plan.type === 1 ? 'Sistema' :
                        'Módulo' }}</span>
                </div>

                <div class="plan-info">
                    <div class="info-row">
                        <span>Terminais</span>
                        <strong>{{ plan.terminalQuantity }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Valor Mensal</span>
                        <strong>R$ {{ plan.monthlyValue | number:'1.2-2'
                            }}</strong>
                    </div>
                </div>

                <!-- Status do Contrato -->
                <div class="plan-status">
                    <ng-container
                        *ngIf="plan.hasContract && isContractSigned(plan)">
                        <div class="contract-signed">
                            <mat-icon>check_circle</mat-icon>
                            <span>Contrato assinado</span>
                            <div class="signed-label">ASSINADO</div>
                        </div>
                    </ng-container>

                    <ng-container
                        *ngIf="plan.hasContract && !isContractSigned(plan)">
                        <div class="contract-pending">
                            <mat-icon>pending</mat-icon>
                            <span>{{ getContractStatusText(plan.contractStatus)
                                }}</span>
                            <button mat-button color="warn" class="remove-btn"
                                *ngIf="plan.canRemoveContract && canEdit"
                                (click)="$event.stopPropagation(); removeContract.emit(plan)">
                                Remover
                            </button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!plan.hasContract">
                        <div class="contract-none">
                            <mat-icon>info</mat-icon>
                            <span>Sem contrato associado</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>